import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/orders/warn.svg")